import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../tokens';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    lpTag: any;
  }
}

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class LiveChatService {
  constructor(@Inject(WINDOW) private windowRef = window) {}

  // this function is for live chat tiles which are not displayed on page load and are show dynamically later which could be behind a CTA button on the page.
  // in this scenario you need to call the following function to reload live person monitor to look for the live person div id to integrate chat.
  reloadLiveAgentMonitor() {    
    this.windowRef?.lpTag?.newPage(window.location.href);
  }
}
